<template>
  <div>
    <template v-if="!hasNoStores">
      <p>{{ $t('components.GuideToSetUpCompetitor.info1') }}</p>
      <p>{{ $t('components.GuideToSetUpCompetitor.info2') }}</p>
      <div v-if="isMoreThanEditor" class="c-button c-button--left">
        <router-link
          :to="{ name: 'CompaniesLocationStoreCompetitorNew', params: { company_uuid: companyUuid, store_uuid: firstStore.attributes.uuid } }"
          class="c-button__item c-button__item--primary"
        >
          {{ $t('components.GuideToSetUpCompetitor.button') }}
        </router-link>
      </div>
    </template>
    <template v-else>
      <p>{{ $t('components.GuideToSetUpCompetitor.noStores.info1') }}</p>
      <p>{{ $t('components.GuideToSetUpCompetitor.noStores.info2') }}</p>
      <div v-if="isMoreThanEditor" class="c-button c-button--left">
        <router-link
          :to="{ name: 'CompaniesLocationStoreNew', params: { company_uuid: companyUuid } }"
          class="c-button__item c-button__item--primary"
        >
          {{ $t('components.GuideToSetUpCompetitor.noStores.button') }}
        </router-link>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'GuideToSetUpCompetitor',
  props: {
    isMoreThanEditor: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    ...mapState({
      stores: state => state.companiesStores.data?.data
    }),
    companyUuid() {
      return this.$route.params.company_uuid
    },
    firstStore() {
      return this.stores[0]
    },
    hasNoStores() {
      return this.stores.length === 0
    }
  },
}
</script>
